import axios from "axios";
import BaseService from "./base-service";
import * as Endpoints from "./endpoints";

/**
 * Service for application configurations loading.
 */
export default class ConfigurationService extends BaseService {

  static getConfigurations() {
    return axios.get(Endpoints.CONFIGURATION)
      .then(this.resolveResponse)
      .catch(this.resolveErrorResponse);
  }
}
